import { createAsyncThunk } from '@reduxjs/toolkit';
import OrganizationsResource from 'api/service/OrganizationsResource';

export const listBrandGroups = createAsyncThunk('organization/listBrandGroups', async (initialData) => {
  const organizationResource = new OrganizationsResource();
  const { id, size = 100, group_types = '', includes = 'member_count, parent_name, admins' } = initialData;
  const params = { size, group_types, includes };
  const { status, data } = await organizationResource.organization(id).listGroups(params);
  if (status === 200) {
    data.forEach((item) => (item.brand = id));
    return data || [];
  }
  return [];
});

export const listGroupsByParent = createAsyncThunk('organization/listGroupsByParent', async (initialData) => {
  const organizationResource = new OrganizationsResource();
  const { id, size = 100, group_types = '', includes = 'parent_name, admins' } = initialData;
  const params = { size, group_types, includes };
  const { status, data } = await organizationResource.organization(id).listGroups(params);
  if (status === 200) {
    return data || [];
  }
  return [];
});

export const getGroup = createAsyncThunk('organization/getGroup', async (initialData, { rejectWithValue }) => {
  const organizationResource = new OrganizationsResource();
  const { brandId, groupId, includes = 'member_count, parent_name, admins' } = initialData;
  const params = { includes };
  const { status, data } = await organizationResource.organization(groupId).read(params);
  if (status === 200) {
    data.brand = brandId;
    return data;
  }
  return rejectWithValue('Organization group fetching failed.');
});

export const createGroup = createAsyncThunk('organization/createGroup', async (initialData, { rejectWithValue }) => {
  const organizationResource = new OrganizationsResource();
  const { brandId, payload, includes = 'member_count, parent_name, admins' } = initialData;
  const params = { includes };
  const { status, data } = await organizationResource.create(payload, params);
  if (status === 201) {
    data.brand = brandId;
    return data;
  }
  return rejectWithValue('Adding of group failed.');
});

export const updateGroup = createAsyncThunk('organization/updateGroup', async (initialData, { rejectWithValue }) => {
  const organizationResource = new OrganizationsResource();
  const { brandId, groupId, payload, includes = 'member_count, parent_name, admins' } = initialData;
  const params = { includes };
  const { status, data } = await organizationResource.organization(groupId).update(payload, params);
  if (status === 200) {
    data.brand = brandId;
    return data;
  }
  return rejectWithValue('Updating of group failed.');
});

export const deleteGroup = createAsyncThunk('organization/deleteGroup', async (initialData, { rejectWithValue }) => {
  const organizationResource = new OrganizationsResource();
  const { id } = initialData;
  const { status } = await organizationResource.organization(id).delete();
  if (status === 202) {
    return id;
  }
  if (status === 400) {
    return rejectWithValue('Unlink subgroup first before deleting.');
  }
  return rejectWithValue('Deleting of group failed.');
});
